export const axiosConfigNoCache = {
  params: {
    t: new Date().getTime(),
  },
};
